import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{attrs:{"top":"","centered":"","color":_vm.color,"timeout":_vm.timeout},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c(VRow,[_c(VCol,{attrs:{"lg":"10","md":"10","sm":"10","align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm.message))])]),_c(VCol,{attrs:{"lg":"2","md":"2","sm":"2"}},[_c(VBtn,{attrs:{"small":"","color":"white","text":""},nativeOn:{"click":function($event){_vm.show = false}}},[_c(VIcon,[_vm._v("mdi-close")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }